import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Order } from '../../../order/models/order';
import { environment } from '../../../../../environments/environment';
import { OrderStateService } from '../../services/order-state.service';
import { DiscountStateService } from '../../../payment/services/discount-state.service';
import { PaymentStateService } from '../../../payment/services/payment-state.service';
import { PaymentGiftStateService } from '../../../payment/services/payment-gift-state.service';
import { OrderLine } from '../../models/order-line';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { BasketService } from '../../services/basket.service';

@Component({
  selector: 'app-basket-simple-view',
  templateUrl: 'basket-simple-view.component.html',
  styleUrls: ['basket-simple-view.component.scss']
})
export class BasketSimpleViewComponent {
  @Input() title = 'Order';
  @Input() header: string;
  @Input() allowDeleteLastDate = false;

  @Input()
  readonly = false;

  @Input()
  debug = false;

  @Output()
  orderLinesRemovedByDate = new EventEmitter<Date>();

  faTrash = faTrash;

  constructor(
    private orderStateService: OrderStateService,
    private discountStateService: DiscountStateService,
    private paymentGiftStateService: PaymentGiftStateService,
    private paymentStateService: PaymentStateService,
    private basketService: BasketService,
  ) {
  }

  toMoneyStr(x: number): string {
    return environment.globalSettings.toMoneyStr(x);
  }

  get order(): Order {
    return this.orderStateService.order;
  }

  get discountAmount(): number {
    return this.discountStateService.totalAmountDiscountCoupons;
  }

  get giftcardAmount(): number {
    return this.paymentGiftStateService.totalAmountRedeemedGiftCards;
  }

  get paymentGiftMessage(): string {
    return this.paymentStateService.isPartnerCodePaymentAllowed
      ? 'RFID Card' : 'Gifrcard';
  }

  getOrderLineBookingDateInfo(orderLine: OrderLine): string {
    if (!orderLine || !orderLine.eventDateStart) {
      return '';
    }

    return orderLine.eventDateStart.toLocaleDateString() + ' ' + orderLine.eventDateStart.toLocaleTimeString();
  }

  getGroupHeaderParams(date: Date): any {
    return this.basketService.getGroupHeaderParams(this.order, date);
  }

  get dates(): Date[] {
    return this.basketService.getDates(this.order);
  }

  get datesExist(): boolean {
    return this.dates.filter(date => date).length !== 0;
  }

  getOrderLines(date: Date): OrderLine[] {
    return this.basketService.getOrderLines(this.order, date);
  }

  deleteLinesByDate(date: Date): void {
    if (!this.order || !this.order.orderLines) {
      return;
    }
    const lines = this.getOrderLines(date);
    if (!lines) {
      return;
    }
    for (const line of lines) {
      line.quantity = 0;
      this.order.deleteOrderLine(line);
    }

    this.orderLinesRemovedByDate.emit(date);
  }

  get allowDelete(): boolean {
    return !this.readonly && (this.allowDeleteLastDate || this.dates.length > 1);
  }

  onLoadOrder(): void {
    this.orderStateService.orderLoadFromLocalStorage();
  }

  onSaveOrder(): void {
    this.orderStateService.orderSaveToLocalStorage();
  }
}
